import { render, staticRenderFns } from "./DeviceAlarmTable.vue?vue&type=template&id=2253e0e4"
import script from "./DeviceAlarmTable.vue?vue&type=script&lang=ts"
export * from "./DeviceAlarmTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports